import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AppEventData, AppEventType } from '../enums/app-events.enum';

interface AppEvent<T extends AppEventType> {
  type: T;
  data: AppEventData[T];
}

@Injectable({
  providedIn: 'root',
})
export class EventBusService {
  private subject = new Subject<AppEvent<keyof AppEventData>>();

  constructor() {}

  emit<T extends keyof AppEventData>(event: AppEvent<T>): void {
    this.subject.next(event);
  }

  on<T extends AppEventType | AppEventType[]>(
    eventType: T, 
    action: (data: AppEventData[T extends AppEventType[] ? T[number] : T]) => void
  ): Subscription {
    return this.subject
      .pipe(
        filter((event): event is AppEvent<T extends AppEventType[] ? T[number] : T> => (
          Array.isArray(eventType) 
            ? eventType.includes(event.type) 
            : event.type === eventType
        )),
        map(event => event.data)
      )
      .subscribe(action);
  }
}
